module.exports = __webpack_public_path__ + "static/img/logo01.4cac033.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/logo01.png
// module id = OLQK
// module chunks = 1